export default __webpack_public_path__ + "static/media/pulp-paper.ea03a198.png";